import { defineNuxtPlugin, useHead, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  if (
    config.public.disableRUM === 'true' ||
    process.env.NODE_ENV !== 'production'
  ) {
    return
  }

  if (process.server) {
    const rumScript = `/* SpeedCurve RUM Snippet v2.0.0 */LUX=function(){var n=Math.floor;function t(){return Date.now?Date.now():+new Date}var r,a=t(),e=window.performance||{},i=e.timing||{navigationStart:(null===(r=window.LUX)||void 0===r?void 0:r.ns)||a};function o(){return e.now?n(e.now()):t()-i.navigationStart}(LUX=window.LUX||{}).ac=[],LUX.addData=function(n,t){return LUX.cmd(["addData",n,t])},LUX.cmd=function(n){return LUX.ac.push(n)},LUX.getDebug=function(){return[[a,0,[]]]},LUX.init=function(n){return LUX.cmd(["init",n||o()])},LUX.mark=function(){for(var n=[],t=0;t<arguments.length;t++)n[t]=arguments[t];if(e.mark)return e.mark.apply(e,n);var r=n[0],a=n[1]||{};void 0===a.startTime&&(a.startTime=o());LUX.cmd(["mark",r,a])},LUX.markLoadTime=function(){return LUX.cmd(["markLoadTime",o()])},LUX.startSoftNavigation=function(){return LUX.cmd(["startSoftNavigation",o()])},LUX.measure=function(){for(var n=[],t=0;t<arguments.length;t++)n[t]=arguments[t];if(e.measure)return e.measure.apply(e,n);var r,a=n[0],i=n[1],u=n[2];r="object"==typeof i?n[1]:{start:i,end:u};r.duration||r.end||(r.end=o());LUX.cmd(["measure",a,r])},LUX.on=function(n,t){return LUX.cmd(["on",n,t])},LUX.send=function(n){return LUX.cmd(["send",n])},LUX.snippetVersion="2.0.0",LUX.ns=a;var u=LUX;return window.LUX_ae=[],window.addEventListener("error",function(n){window.LUX_ae.push(n)}),u}();`

    nuxtApp.vueApp.runWithContext(() => {
      useHead({
        script: [
          {
            innerHTML: 'LUX = window.LUX || {};LUX.auto=false',
            type: 'text/javascript',
            id: 'pre-speedcurve-rum-script',
            tagPriority: 1,
          },
          {
            innerHTML: rumScript,
            type: 'text/javascript',
            id: 'speedcurve-rum-script',
            tagPriority: 2,
          },
          {
            src: `https://cdn.speedcurve.com/js/lux.js?id=${config.public.speedcurveRumId || '4595058091'}`,
            type: 'text/javascript',
            async: true,
            crossorigin: 'anonymous',
            id: 'speedcurve-rum-script-external',
            tagPriority: 3,
          },
        ],
      })
    })
  }

  if (process.client) {
    const router = useRouter()
    router.beforeEach(() => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: Type LUX properly
        if (window.LUX && window.LUX.startSoftNavigation) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- LUX is untyped window property
          const LUX = window.LUX
          // LUX.label = from.matched[0]?.name || 'data-missing'
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- TODO: Type LUX properly
          LUX.startSoftNavigation()
        }
      } catch (_e) {
        console.error(_e)
      }
    })
  }
})
